import { useEffect, useState } from "react";
import resorti from "../../images/resorti.png";
import martysi from "../../images/martysi.png";
import cleaningServices from "../../images/cleaningServices.png";
import Mobilenav from "../components/mobilenav";
import { Link } from "react-router-dom";
import LazyLoad from 'react-lazyload';
import { useRef, useContext } from "react";
import {AppContext} from '../components/currentTheme'
import Cookies from 'universal-cookie';
import "../../styless/pages/_portfolio.scss"
import { removePathName } from "../components/nav";

const cookies = new Cookies()
export default function Portfolio(){
  let resortIma = useRef()
  let shadere = useRef()
  let shadema = useRef()
  let martysIma = useRef()
  let shadefr = useRef()
  let frankIma = useRef()

    const { theme } = useContext(AppContext);
    const [navLinkStyle, setNavLinkStyle] = useState(
      {homeLinkColor:"gray",
      servicesLinkColor:"gray",
      previewLinkColor:"gray",
      aboutLinkColor:"gray",
    })
    
    function animateImage (){
      if(resortIma.current){
        const buttons = document.getElementsByClassName('previewsButton')
        const images = document.getElementsByClassName('previewsImages')

        for(let image of images){
          image.style.animation = 'moveImage 0.5s ease-in-out'  
          image.addEventListener('animationend', function resetAnimation() {
          image.style.animation = 'none'
          image.removeEventListener('animationend', resetAnimation); 
        });
        }

        for(let button of buttons){
          button.style.animation = 'buttonAnimation 0.6s ease-out forwards'
        }
      }
      
    }

    useEffect(()=>{
      document.body.style.overflowY = 'visible';
      return ()=>{
        document.body.style.overflowY = 'hidden';
      }
    },[])

    useEffect(()=>{
      removePathName()
      if (theme === 'light') {
          document.body.classList.add('light');
          document.body.classList.remove('dark');
        } else {
          document.body.classList.add('dark');
          document.body.classList.remove('light');
        
        }
    },[theme])

    function linkHover(link){
    let updatedNavLinkStyle = {...navLinkStyle}
    updatedNavLinkStyle[link] = "white"
    setNavLinkStyle(updatedNavLinkStyle)
   }
   
   function linkNotHover(link){
    let updatedNavLinkStyle = {...navLinkStyle}
    updatedNavLinkStyle[link] = "gray"
    setNavLinkStyle(updatedNavLinkStyle)
    }
  
   function buttonHover(image, shade){
    image.current.style.opacity="0.5"
    shade.current.style.background="black"
    image.current.style.animation="none"
    shade.current.style.animation="none"
    
   }

   function buttonNotHover(image, shade){
    image.current.style.opacity="1"
    shade.current.style.backgroundColor="transparent"
    image.current.style.animation="none"
    shade.current.style.animation="none"
   }

   function navLinkAction(){
    //code that is executed after a nav link is pressed
    
  }

   return(
          <>
      <div id="previewsNav">
                <Link to="/"  id="Porthome" onClick={navLinkAction} 
                 style={{color:navLinkStyle.homeLinkColor, marginLeft:"20vh"}} 
                onMouseOver={()=>{linkHover("homeLinkColor")}}
                onMouseOut={()=>{linkNotHover("homeLinkColor")}}
                >Home</Link>

                <Link to={"/services"} id="skills"  onClick={navLinkAction} 
                style={{color:navLinkStyle.servicesLinkColor }} 
                onMouseOver={()=>{linkHover("servicesLinkColor")}}
                
                onMouseOut={()=>{linkNotHover("servicesLinkColor")}}
                className="Portlinks" >Services</Link>

               <Link to={"/demos"} id="work"  style={{color:navLinkStyle.previewLinkColor}} 
               
               onMouseOver={()=>{linkHover("previewLinkColor")}} 
              onMouseOut={()=>{linkNotHover("previewLinkColor")}}
               className="Portlinks">Demos</Link>

                <Link to="/about" id="about"  onClick={navLinkAction} className="Portlinks"
                onMouseOver={()=>{linkHover("aboutLinkColor")}} 
                onMouseOut={()=>{linkNotHover("aboutLinkColor")}}
                style={{color:navLinkStyle.aboutLinkColor}} >About</Link>

              </div>
              
            <Mobilenav current={"/previews"}/> 
          
             <div id="previewsContent">
              
             
                <div id="coloroverRe" ref={shadere}>
                  
                    <a href="https://danielfrancisco.github.io/Resort/" target="_blank">
                      <img className='previewsImages' ref={resortIma} src={resorti} onMouseOver={()=>{buttonHover(resortIma, shadere)}} 
                       onMouseOut={()=>{buttonNotHover(resortIma, shadere)}} 
                       style={{animation:'defaultState 0s ease-out forwards'}}
                       onLoad={animateImage}/>
                    </a>
                    
                    <a href="https://danielfrancisco.github.io/Resort/" target="_blank">
                      <button className='previewsButton' onMouseOver={()=>{buttonHover(resortIma, shadere)}} 
                       onMouseOut={()=>{buttonNotHover(resortIma, shadere)}} 
                       style={{animation:'defaultState 0s ease-out forwards'}}
                       >
                        Get a Demo </button>
                    </a>
                   </div>
                
                  
                <LazyLoad  >
                    <div id="coloroverMa" ref={shadema}>
                      <a  target="_blank" href="https://danielfrancisco.github.io/martyswebapp/#/">
                        <img className='previewsImages' src={martysi} ref={martysIma}  onMouseOver={()=>{buttonHover(martysIma, shadema)}} 
                       onMouseOut={()=>{buttonNotHover(martysIma, shadema)}} 
                       style={{animation:'defaultState 0s ease-out forwards'}}
                       />
                      </a>
                  
                        <a href="https://danielfrancisco.github.io/martyswebapp/#/" target="_blank">
                          <button className='previewsButton' onMouseOver={()=>{buttonHover(martysIma, shadema)}} 
                       onMouseOut={()=>{buttonNotHover(martysIma, shadema)}}
                       style={{animation:'defaultState 0s ease-out forwards'}}>
                        Get a demo </button></a>
                     </div>
                  </LazyLoad>

                  <LazyLoad>
                   <div id="coloroverFr" ref={shadefr}>

                    <a href="https://danielfrancisco.github.io/cleaningServices/" target="_blank">
                      <img className='previewsImages' src={cleaningServices} ref={frankIma} onMouseOver={()=>{buttonHover(frankIma, shadefr)}} 
                       onMouseOut={()=>{buttonNotHover(frankIma, shadefr)}}
                       style={{animation:'defaultState 0s ease-out forwards'}}/>
                    </a>
                  

                  <a href="https://danielfrancisco.github.io/cleaningServices/" target="_blank">
                    <button className='previewsButton' onMouseOver={()=>{buttonHover(frankIma, shadefr)}} 
                       onMouseOut={()=>{buttonNotHover(frankIma, shadefr)}}
                       style={{animation:'defaultState 0s ease-out forwards'}}>
                      Get a Demo 
                      </button></a>

                  </div>

                  </LazyLoad>
               </div>
              
            </>
      )

    }
  